// Pre-send reminders shared by both email composers (ComposeNew = new email / draft, Composer =
// reply / reply-all / forward). None of them blocks: SendCheckModal shows them and the user either
// goes back to fix the email or sends it anyway (Calem 2026-09-23, Bugify #594776d4).

export type SendWarning =
  | { kind: 'no_subject' }
  | { kind: 'no_attachment'; word: string };   // `word` = what the user typed, e.g. "Attached"

// Whole words only, any case — "unattached" doesn't count. The plural is the same word:
// "please see the attachments" forgets the files just as easily.
const ATTACH_WORD = /\b(attached|attachments?)\b/i;

// The user's own words as plain text. Both composers keep the signature and the replied/forwarded
// original OUTSIDE the editor, so only the message itself arrives here; a <blockquote> inside it is
// quoted history too (e.g. a draft begun in Gmail) and is dropped. Every block/line break becomes a
// space so "…see below</p><p>Attached…" still reads as two separate words.
function ownText(userHtml: string): string {
  const doc = new DOMParser().parseFromString(userHtml, 'text/html');
  doc.querySelectorAll('blockquote').forEach(q => q.remove());
  doc.querySelectorAll('br, p, div, li, h1, h2, h3, h4, h5, h6, pre').forEach(el => el.after(' '));
  return doc.body.textContent || '';
}

export function sendWarnings(subject: string, userHtml: string, attachmentCount: number): SendWarning[] {
  const out: SendWarning[] = [];
  if (!subject.trim()) out.push({ kind: 'no_subject' });
  const m = attachmentCount === 0 ? ownText(userHtml).match(ATTACH_WORD) : null;
  if (m) out.push({ kind: 'no_attachment', word: m[0] });
  return out;
}
